<template>
  <div>
    <el-row>
      <CoreTableContainer        
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfigComp"
        ref="CoreTableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <!-- <el-button type="primary" icon="el-icon-circle-plus-outline">增加学员</el-button> -->
          </router-link>
        </template>

        <template v-slot:filter>
            <PartyOrgSelect :size="'small'" @onValueChanged="onPartyOrgValueChanged" v-show="isAdmin"></PartyOrgSelect>
            <ClassUnitSelect :size="'small'"  @onValueChanged="onClassUnitValueChanged" v-show="isAdmin"></ClassUnitSelect>          
            <CCPSelect  @onValueChanged="onCCPValueChanged"></CCPSelect>          
            <CheckSelect @onValueChanged="onCheckValueChanged"></CheckSelect>          
            <RetiredSelect @onValueChanged="onRetiredValueChanged"></RetiredSelect>          
            <ZaibianSelect @onValueChanged="onZaibianValueChanged"></ZaibianSelect>          
        </template>

        <!--  -->
        <template v-slot:table__footer__info>学员列表</template>
      </CoreTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>


<script>

import { CoreTableContainer } from "@/core/table/";
import { PartyOrgSelect } from "@/views/module/partyOrganization/components"
import { ClassUnitSelect } from "@/views/module/classunit/components"
import { CCPSelect,CheckSelect,RetiredSelect,ZaibianSelect } from "@/views/module/user/comp"

export default {
  name: "userpage",
  components: {
    CoreTableContainer,PartyOrgSelect,ClassUnitSelect,CCPSelect,CheckSelect,RetiredSelect,ZaibianSelect
  },
  data() {
    return {
      containerTableColumns : [
      {
          prop: "cdatestr",
          label: "创建时间",
          width: "110px"
        },
        {
          prop: "name",
          label: "学员名",
          width: "100px"
        },
        {
          prop: "isccp",
          label: "是否是党员",
          width: "120px",
          convertRow: (row) => {
            if(row.isccp == 0){
              return "非党员";
            }
            else {
              if(row.zaibian){
                return "党员"
              }
              else {
                return "党员（非在编）"
              }
            }
          }
        },
        {
          prop: "iscomplete",
          label: "是否已使用",
          width: "100px",
          convert: (val) => {
            if(val){
              return "已使用"
            }
            else {
              return "未登录"
            }
          }
        },
        {
          prop: "retire",
          label: "是否退休",
          width: "100px",
          convert: (val) => {
            if(val){
              return "退休"
            }
            else {
              return "在职"
            }
          }
        },
        {
          prop: "unittitle",
          label: "所属单位",
          // width: "200px"
        },
        {
          prop: "partytitle",
          label: "所属党组织",
          // width: "200px"
        }
      ],
      containerBaseUrl : "/user",
      containerServerUrl :  "/api/manager/user",
      tableToolConfig: {
            canEdit: true,
            canRecover: true,
            canDelete: true,
            canDisable: true
      },
    }
  },
  methods: {
    onPartyOrgValueChanged(partyid){
      this.$refs.CoreTableContainer.updateParams("partyid",partyid);
    },

    onClassUnitValueChanged(unitid){
      this.$refs.CoreTableContainer.updateParams("unitid",unitid);

    },

    onCCPValueChanged(ccpid){
      this.$refs.CoreTableContainer.updateParams("ccpid",ccpid);
    },

    onCheckValueChanged(check){
      this.$refs.CoreTableContainer.updateParams("checkid",check);
    },

    onRetiredValueChanged(retired){
      this.$refs.CoreTableContainer.updateParams("retired",retired);
    },

    onZaibianValueChanged(zaibian){
      this.$refs.CoreTableContainer.updateParams("zaibian",zaibian);
    }
  },
  computed:{
    isAdmin(){
      return this.$store.getters["profileModule/isadmin"];
    },
    tableToolConfigComp(){
      if(this.isAdmin){
        return {
            canEdit: true,
            canRecover: true,
            canDelete: true,
            canDisable: true
        }
      }
      else {
        return {
            canEdit: true,
            canRecover: false,
            canDelete: false,
            canDisable: false
        }
      }
    }
  }


}



</script>




<style scoped>
</style>